import { useState, useEffect } from "react";
import { Calendar } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";

const StickyBookButton = ({ openBookingModal }) => {
  const { language } = useLanguage();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 300);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      {/* Desktop - Bottom Right, above other floating elements */}
      <button
        onClick={openBookingModal}
        className={`hidden md:flex fixed bottom-8 right-8 z-[70] items-center gap-2.5 bg-black hover:bg-zinc-900 text-white pl-5 pr-6 py-3.5 rounded-full shadow-2xl hover:shadow-[0_8px_30px_rgba(0,0,0,0.4)] transition-all duration-300 border border-amber-500/30 hover:border-amber-500/60 ${
          isVisible ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0 pointer-events-none"
        }`}
        style={{ fontFamily: "'Playfair Display', serif" }}
        data-testid="sticky-book-desktop"
      >
        <Calendar className="w-5 h-5 text-amber-400" />
        <span className="text-sm font-semibold uppercase tracking-wider">
          {language === "fr" ? "Réserver" : "Book Now"}
        </span>
      </button>

      {/* Mobile - Hidden: Bottom nav bar already has Book button */}
    </>
  );
};

export default StickyBookButton;
